import React from 'react';
import styles from './index.module.scss';
import EcoEmail from 'eco-design/elements/eco-email';
import EcoImg from 'eco-design/base/eco-img';
import { getSubscribeParams } from './config';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import { subscribeTran } from './lang';

const SubscribeWinUltraA: React.FC = () => {
    const { t } = useLang('theProduct.SubscribeWinUltraA');
    const { locale } = getLocal();
    const subscribeData = getSubscribeParams(locale);
    const textObj = subscribeTran[locale] || subscribeTran['eu'];

    return (
        <>
            <section
                className={`${styles.SubscribeWinUltraA} GtmModuleData-section`}
                data-section-id="SubscribeWinUltraA2"
                data-section-title={t('subscribe_win_title')}
            >
                <div className="container-inner">
                    <div className="content-area">
                        <div className="title-box">
                            {/* <div className="content-title">{pageStatus === IPageStatus.statusA ? t('subscribe_win_title') : t('subscribe_win_title2')}</div>
                            <p className="sub-title">{t('subscribe_win_subtitle')}</p> */}
                        </div>
                        <div className="subscribe-container">
                            <div className="subscribe-container-innner">
                                <div className="subscribe-area">
                                    <div className="title">{t('subscribec_title')}</div>
                                    <EcoEmail
                                        tipsObj={textObj}
                                        termsHtml={textObj.termsHtml}
                                        contactListId={subscribeData.contactListId}
                                        fields={subscribeData.fields}
                                        dataLayer={{
                                            button_name: textObj.btnText,
                                            event: 'uaEvent',
                                            event_name: 'activity_submit',
                                        }}
                                        subscribeData={{
                                            sector_name: t('subscribec_title'),
                                            entry_position: 6,
                                        }}
                                    />
                                </div>
                            </div>
                            <EcoImg
                                className=""
                                pc="https://websiteoss.ecoflow.com/upload/image/1749283190157/sub-pc.jpg"
                                pad="https://websiteoss.ecoflow.com/upload/image/1749283190157/sub-pc.jpg"
                                h5="https://websiteoss.ecoflow.com/upload/image/1749283207802/sub-m.jpg"
                            ></EcoImg>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default SubscribeWinUltraA;
